import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export const fetchAllOdersList = createAsyncThunk(
  "orders/fetchAllOdersList",
  async ({ page = 1, limit = 10 } = {}, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(`/orders/list?page=${page}&limit=${limit}`);
      return data;
    } catch (error) {
      return rejectWithValue("Failed to fetch orders");
    }
  }
);
export const fetchBuyAgainOdersList = createAsyncThunk(
  "orders/fetchBuyAgainOdersList",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(`/orders/buy-again-order-list`);
      return data;
    } catch (error) {
      return rejectWithValue("Failed to fetch user");
    }
  }
);

export const fetchOrdersDetailsById = createAsyncThunk(
  "orders/fetchOrdersDetailsById",
  async (order_id, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(
        `/orders/get-order-info?order_id=${order_id}&activity_logs=true`
      );
      return data.data;
    } catch (error) {
      return rejectWithValue("Failed to fetch user");
    }
  }
);
// Cancel Order

export const cancelOrder = createAsyncThunk(
  "orders/cancelorder",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/orders/cancel-order",
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue("Failed to cancel order");
    }
  }
);

// Cancel Zelle Order
export const cancelZelleOrder = createAsyncThunk(
  "orders/cancelZelleOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/orders/cancel-zelle-order",
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue("Failed to cancel Zelle order");
    }
  }
);

// Fetch Subscriptions
export const fetchSubscriptions = createAsyncThunk(
  "orders/fetchSubscriptions",
  async ({ page = 1, limit = 10 } = {}, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(
        `/subscriptions/?page=${page}&limit=${limit}`
      );
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch subscriptions"
      );
    }
  }
);

// Fetch Subscriptions Details
export const fetchSubscriptionsDetails = createAsyncThunk(
  'orders/fetchSubscriptionsDetails',
  async (SubscriptionId, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`/subscriptions/${SubscriptionId}`);
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch product details',
      );
    }
  },
);

// Fetch Subscriptions Pause
export const subscriptionsPause = createAsyncThunk(
  'orders/subscriptionsPause',
  async (payload, { rejectWithValue }) => {
    try {
      const { subscriptionId, reason, next_delivery_date } = payload;
      const requestBody = {};
      if (reason) {
        requestBody.reason = reason;
      }
      if (next_delivery_date) {
        requestBody.next_delivery_date = next_delivery_date;
      }
      const response = await axiosInstance.post(
        `/subscriptions/${subscriptionId}/pause`,
        requestBody
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to pause subscription',
      );
    }
  },
);

// Fetch Subscriptions Resume
export const subscriptionsResume = createAsyncThunk(
  'orders/subscriptionsResume',
  async (payload, { rejectWithValue }) => {
    try {
      const { subscriptionId, next_delivery_date } = payload;
      const response = await axiosInstance.post(
        `/subscriptions/${subscriptionId}/resume`,
        { next_delivery_date }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to resume subscription',
      );
    }
  },
);

// Fetch Subscriptions Cancel
export const subscriptionsCancel = createAsyncThunk(
  'orders/subscriptionsCancel',
  async (payload, { rejectWithValue }) => {
    try {
      const { subscriptionId, reason } = payload;
      const requestBody = {};
      if (reason) {
        requestBody.reason = reason;
      }
      const response = await axiosInstance.post(
        `/subscriptions/${subscriptionId}/cancel`,
        requestBody
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to cancel subscription',
      );
    }
  },
);

// Skip Delivery
export const skipDelivery = createAsyncThunk(
  'orders/skipDelivery',
  async (payload, { rejectWithValue }) => {
    try {
      const { subscriptionId, scheduleId, skip_reason } = payload;
      const requestBody = {};
      if (skip_reason) {
        requestBody.skip_reason = skip_reason;
      }
      const response = await axiosInstance.post(
        `/subscriptions/${subscriptionId}/schedules/${scheduleId}/skip`,
        requestBody
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to skip delivery',
      );
    }
  },
);

// Update Subscription Payment
export const updateSubscriptionPayment = createAsyncThunk(
  'orders/updateSubscriptionPayment',
  async (payload, { rejectWithValue }) => {
    try {
      const { subscriptionId, payment_method, payment_id } = payload;
      const response = await axiosInstance.put(
        `/subscriptions/${subscriptionId}/payment`,
        { payment_method, payment_id }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to update payment method',
      );
    }
  },
);

// Update Subscription Delivery
export const updateSubscriptionDelivery = createAsyncThunk(
  'orders/updateSubscriptionDelivery',
  async (payload, { rejectWithValue }) => {
    try {
      const { subscriptionId, delivery_method, pickup_id } = payload;
      const response = await axiosInstance.put(
        `/subscriptions/${subscriptionId}/delivery`,
        { delivery_method, pickup_id }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to update delivery method',
      );
    }
  },
);

// Update Subscription Items
export const updateSubscriptionItems = createAsyncThunk(
  'orders/updateSubscriptionItems',
  async (payload, { rejectWithValue }) => {
    try {
      const { subscriptionId, items, update_reason } = payload;
      const response = await axiosInstance.put(
        `/subscriptions/update/${subscriptionId}`,
        { items, update_reason }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to update subscription items',
      );
    }
  },
);

// Fetch Order Count By Pickup Date
export const fetchOrderCountByPickupDate = createAsyncThunk(
  'orders/fetchOrderCountByPickupDate',
  async (pickup_date, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(
        `/orders/stats/order-count-by-pickup-date?pickup_date=${pickup_date}`
      );
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch order count',
      );
    }
  },
);

// Add Order Notes
export const addOrderNotes = createAsyncThunk(
  'orders/addOrderNotes',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post('/orders/add-notes', payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to add order notes',
      );
    }
  },
);
